const mapArrayToObjectsByKey = (arr, key) => Object.fromEntries(arr.map((item) => [item[key], item]));

export {
  mapArrayToObjectsByKey,
};
